import React from 'react';

import ModalWrap from '../modal-wrap';
import { CloseCrossBtn } from '../../icons/close-cross-btn';
import Button from '../../common/button';

interface IModalProps {
  isConfirmCloseOpen: boolean;
  cancelCloseTool: () => void;
  confirmCloseTool: () => void;
  confirmMessage: string;
  title: string;
  cancelText: string;
  nonCancelText: string;
}

const Modal: React.FC<IModalProps> = ({
  isConfirmCloseOpen,
  cancelCloseTool,
  confirmMessage,
  confirmCloseTool,
  title,
  cancelText,
  nonCancelText,
}) => {
  return (
    <ModalWrap isShow={isConfirmCloseOpen}>
      <div className="think-scroll flex flex-col gap-6 w-full max-w-[90%] sm:max-w-[60%] md:w-[630px] h-auto rounded-[20px]  p-6 lg:p-10 bg-white shadow-shadowPopup">
        <div className="w-full flex justify-between items-start">
          <h2 className="font-comfortaa text-lg lg:text-2xl text-[#111026] font-bold">{title}</h2>
          <button className="cursor-pointer" onClick={cancelCloseTool} aria-label="Отменить закрытие">
            <CloseCrossBtn width={20} height={20} />
          </button>
        </div>
        <p className="text-sm md:text-base font-bold text-[#585858]">{confirmMessage}</p>
        <div className="flex  gap-4">
          <Button type="grey" className="w-full px-4 py-2 !text-sm md:!text-base" onClick={confirmCloseTool}>
            {cancelText}
          </Button>
          <Button type="black" className="w-full px-4 py-2 !text-sm md:!text-base" onClick={cancelCloseTool}>
            {nonCancelText}
          </Button>
        </div>
      </div>
    </ModalWrap>
  );
};

export default Modal;
